import Ajax from "src/ajax"
import get from "lodash/get"

const path = "order"

/**
 * Actions
 */
const FETCH_REQUEST = `${path}/fetch-request`
const FETCH_REQUEST_ADDRESS_BOOK_SUCCESS = `${path}/fetch-address-book-success`
const FETCH_REQUEST_FAIL = `${path}/fetch-fail`

const ACTION_REQUEST = `${path}/action-request`
const ACTION_REQUEST_SUCCESS = `${path}/action-success`
const ACTION_REQUEST_FAIL = `${path}/action-fail`
// const ACTION_FETCH_DETAIL_SUCCESS = `${path}/action-fetch-detail-success`
const ACTION_REQUEST_CALCULATE_SUCCESS = `${path}/action-calculate-success`

const SELECT_ACCOUNT = `${path}/select-account`
const SET_SLUG = `${path}/set-slug`

/**
 * Action Creators
 */

export const selectAccount = (account) => ({
  type: SELECT_ACCOUNT,
  payload: account,
})

/**
 * Side Effects
 */
export const fetchAddressBook = (_id) => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST })
  try {
    const options = {
      method: "GET",
      url: `user/${_id}/address-book`,
    }
    const response = await Ajax(options)
    const list = response.data.address_book
    const total = response.data.total
    dispatch({
      type: FETCH_REQUEST_ADDRESS_BOOK_SUCCESS,
      payload: { list, total },
    })
  } catch (error) {
    const error_text = get(error, "response.data.error")
    // set fetching = false + error text
    dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text })
  }
}

export const processOrder = (payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: "POST",
      url: path + "/calculate",
      data: payload,
    }
    const response = await Ajax(options)
    const calculate = response.data.calculate
    dispatch({ type: ACTION_REQUEST_CALCULATE_SUCCESS, payload: calculate })
  } catch (error) {
    const error_array = get(error, "response.data.errors")
    dispatch({ type: ACTION_REQUEST_FAIL, payload: "error" })
    throw error_array
  }
}

export const createOrder = (payload) => async (dispatch) => {
  dispatch({ type: ACTION_REQUEST })
  try {
    const options = {
      method: "POST",
      url: path,
      data: payload,
    }
    const response = await Ajax(options)
    const slug = response.data.order.slug.order
    dispatch({ type: ACTION_REQUEST_SUCCESS })
    dispatch({ type: SET_SLUG, payload: slug })
  } catch (error) {
    const error_array = get(error, "response.data.errors")
    dispatch({ type: ACTION_REQUEST_FAIL, payload: "error" })
    throw error_array
  }
}

/**
 * Initial State
 */
const initialState = {
  // account
  account: {},
  // step
  step: 1,
  // address book
  fetching: false,
  address_book: [],
  total: 0,
  // slug after created
  slug: "",
  // loading for create & edit
  processing: false,
  error: null,
  // calculate cart bundle for
  calculate: {},
}

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_REQUEST_ADDRESS_BOOK_SUCCESS:
      return {
        ...state,
        fetching: false,
        address_book: action.payload.list,
        total: action.payload.total,
      }
    case FETCH_REQUEST_FAIL:
      return { ...state, fetching: false, error: action.payload }

    case ACTION_REQUEST:
      return { ...state, processing: true, error: null }
    case ACTION_REQUEST_SUCCESS:
      return { ...state, processing: false }
    case ACTION_REQUEST_FAIL:
      return { ...state, processing: false, error: action.payload }
    case ACTION_REQUEST_CALCULATE_SUCCESS:
      return { ...state, processing: false, calculate: action.payload }

    case SET_SLUG:
      return { ...state, slug: action.payload }

    case SELECT_ACCOUNT:
      return { ...state, account: action.payload }
    default:
      return state
  }
}
